export class AuthorizedPickupPerson{
    pk?: number;
    first_name?: string;
    last_name?: string;
    id_number?: string;
    id_type?: string;
    user?: string;
}